import { IsOptional } from 'class-validator';
import { EpimsBaseEntityDto } from './epim-base.dto';
import { AccountableFunctionLink2Dto, PipelineAssetLink2Dto } from '@cradua/data';
import { PipelineSectionDto } from './pipelinesection.dto';
export class PipelineDetailsDto extends EpimsBaseEntityDto {
    
  AutoSerialId: string;
  PipelineCode: string;
  PipelineName: string;
  InstallationYear: string;
  OPLLNumber: string;
  PTSNumber: string;
  DeliveryTypeId: string;
  AssetStatusId: string;
  NetworkId: string;
  PigibilityId: string;
  IpStatusId: string;
  LicenceStatusId: string;
  PipelineGradeId: string;
  LengthUOMId: string;
  LengthUOMName: string;
  Length: number;
  DiameterUOMId: string;
  DiameterUOMName: string;
  Diameter: number;
  WallThicknessUOMId: string;
  WallThicknessUOMName: string;
  WallThickness: number;
  DesignedPressureUOMId: string;
  DesignedPressureUOMName: string;
  DesignedPressure: number;
  Remarks: string;
  PipelineAssetLocationId: string;
  TerrainId: string;
  TerrianName: string;
  AccountableFunctionId: string;
  AccountableFunctionName: string;
  LicenceExpirationDate: Date;
  SubscriberId: string;
  SubscriptionUserId: string;
  pipelineAssetLink2s: PipelineAssetLink2Dto[];
  accountableFunctionLink2s: AccountableFunctionLink2Dto[];
  pipelineSections: PipelineSectionDto[];
  length: number;
  ExpiringDate : Date;
 
  LicenseStartedDate: Date;
  LicenseEndedDate: Date;
  Status: string;
  LicenseStatus: string;
}